import React from 'react';

/**
 * Template 12: Data + Subject
 * Dark bg, bar chart/graph element left, subject image right, serif headline top.
 *
 * Inspired by: "End of Rubber" with WORLD GDP chart
 */
export default function V_DataSubject({
  headline = 'End of Rubber',
  subjectImage,
  bgColor = '#0a0a0a',
  accentColor = '#E53935',
  chartBars = [
    { label: '2020', value: 45, color: '#444' },
    { label: '2021', value: 55, color: '#555' },
    { label: '2022', value: 70, color: '#666' },
    { label: '2023', value: 60, color: '#E53935' },
    { label: '2024', value: 35, color: '#E53935' },
  ],
}) {
  const maxVal = Math.max(...chartBars.map(b => b.value), 1);

  return (
    <div style={{
      width: 1280, height: 720, position: 'relative', overflow: 'hidden',
      background: bgColor, fontFamily: "'Playfair Display', serif",
    }}>
      {/* Headline - top center */}
      <h1 style={{
        position: 'absolute', top: 40, left: 60, right: 60,
        margin: 0, fontSize: 84, fontWeight: 700, lineHeight: 1.05,
        color: '#FFFFFF', zIndex: 2,
        textShadow: '0 4px 20px rgba(0,0,0,0.8)',
      }}>
        {headline}
      </h1>

      {/* Bar chart - left side */}
      <div style={{
        position: 'absolute', left: 60, bottom: 60, width: 520, height: 400,
        zIndex: 2, display: 'flex', alignItems: 'flex-end', gap: 12,
      }}>
        {chartBars.map((bar, i) => {
          const barHeight = (bar.value / maxVal) * 320;
          return (
            <div key={i} style={{
              flex: 1, display: 'flex', flexDirection: 'column',
              alignItems: 'center', gap: 8,
            }}>
              <div style={{
                width: '100%', height: barHeight, borderRadius: '4px 4px 0 0',
                background: bar.color || accentColor,
                transition: 'height 0.3s ease',
              }} />
              <span style={{
                fontSize: 16, color: 'rgba(255,255,255,0.5)',
                fontFamily: "'Inter', sans-serif", fontWeight: 600,
              }}>{bar.label}</span>
            </div>
          );
        })}
        {/* Baseline */}
        <div style={{
          position: 'absolute', bottom: 28, left: 0, right: 0,
          height: 1, background: 'rgba(255,255,255,0.15)',
        }} />
      </div>

      {/* Subject image - right side */}
      {subjectImage ? (
        <div style={{
          position: 'absolute', right: 0, top: 120, width: 600, height: 600,
          zIndex: 1,
        }}>
          <img src={subjectImage} alt="" style={{
            width: '100%', height: '100%', objectFit: 'contain',
          }} />
          {/* Gradient fade into dark bg on left edge */}
          <div style={{
            position: 'absolute', inset: 0,
            background: 'linear-gradient(90deg, rgba(10,10,10,0.8) 0%, transparent 30%)',
          }} />
        </div>
      ) : (
        <div style={{
          position: 'absolute', right: 80, top: '50%', transform: 'translateY(-50%)',
          width: 440, height: 380, background: 'rgba(255,255,255,0.04)',
          borderRadius: 12, zIndex: 1,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 32, color: 'rgba(255,255,255,0.1)',
        }}>SUBJECT</div>
      )}

      {/* Downward trend arrow overlay (when last bars decline) */}
      <svg style={{
        position: 'absolute', left: 420, bottom: 200, width: 80, height: 80, zIndex: 3,
        opacity: 0.6,
      }} viewBox="0 0 80 80">
        <path d="M 10 20 L 60 65" fill="none" stroke={accentColor}
          strokeWidth="4" strokeLinecap="round" />
        <polygon points="55,55 65,68 48,64" fill={accentColor} />
      </svg>
    </div>
  );
}
